import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

import { borderWidths } from "./borderWidths";
import { breakpoints } from "./breakpoints";
import {
  colors,
  semanticColors,
  semanticGradeThemePrimary,
  semanticGradeThemeSecondary,
  semanticGradeThemeSenior
} from "./colors";
import { fontSizes } from "./fontSizes";
import { fonts, semanticFonts } from "./fonts";
import layerStyles from "./layerStyles";
import { recipes, slotRecipes } from "./recipes";
import { textStyles } from "./textStyles";

const baseConfig = {
  // strictTokens: true,
  globalCss: {
    "@media screen and (max-width: 30em)": {
      "& .react-datepicker": {
        width: "100%"
      }
    },
    "::selection": {
      backgroundColor: "#ADD6FF"
    }
  },
  cssVarsPrefix: "euka"
};

const baseTheme = {
  tokens: {
    borderWidths,
    colors,
    fonts,
    fontSizes,
    breakpoints
  },
  semanticTokens: {
    colors: semanticColors,
    fonts: semanticFonts
  },
  textStyles,
  layerStyles,
  recipes,
  slotRecipes
};

export const system = createSystem(
  defaultConfig,
  defineConfig({
    ...baseConfig,
    theme: {
      ...baseTheme
    }
  })
);

export const systemPrimary = createSystem(
  defaultConfig,
  defineConfig({
    ...baseConfig,
    theme: {
      ...baseTheme,
      semanticTokens: {
        ...baseTheme.semanticTokens,
        colors: {
          ...baseTheme.semanticTokens.colors,
          gradeTheme: semanticGradeThemePrimary
        }
      }
    }
  })
);

export const systemSecondary = createSystem(
  defaultConfig,
  defineConfig({
    ...baseConfig,
    theme: {
      ...baseTheme,
      semanticTokens: {
        ...baseTheme.semanticTokens,
        colors: {
          ...baseTheme.semanticTokens.colors,
          gradeTheme: semanticGradeThemeSecondary
        }
      }
    }
  })
);

export const systemSenior = createSystem(
  defaultConfig,
  defineConfig({
    ...baseConfig,
    theme: {
      ...baseTheme,
      semanticTokens: {
        ...baseTheme.semanticTokens,
        colors: {
          ...baseTheme.semanticTokens.colors,
          gradeTheme: semanticGradeThemeSenior
        }
      }
    }
  })
);
